import { observer } from 'mobx-react';

import css from './ConfigurationRestorer.css';
import { ConfigurationRestorerState } from './ConfigurationRestorerState';

interface ConfigurationRestorerProps {
  state: ConfigurationRestorerState;
}

const ConfigurationRestorer = observer(({ state }: ConfigurationRestorerProps) => {
  if (!state.restoreIncomplete) {
    return null;
  }

  return (
    <div className={css.message}>
      We were not able to fully restore the configuration with code {state.configurationCodeToRestore}.
      <br />
      Please complete it manually.
    </div>
  );
});

export default ConfigurationRestorer;
